
<template>
  <div class="columns is-gapless" style="width:200px">
    <div class="column">
      <p class="control">
          <the-mask mask="##:##" class="input hour-input" v-model="monthTimeFrom" :disabled="isApproved" />
          <span class="help" v-if="checkTimeFromError">{{ $t("input.hourFormatError") }}</span>
      </p>
    </div>
    <div class="column">
      <p class="control">
          <the-mask mask="##:##" class="input hour-input" v-model="monthTimeTo" :disabled="isApproved" />
          <span class="help" v-if="checkTimeToError && daySum < 0">{{ $t("input.hourFormatError") }}</span>
      </p>
    </div>
    <div class="column">
      <a v-if="dayTimeSum > 24 || dayTimeSum < 0" class="button is-small is-danger is-outlined is-pulled-right" disabled>{{$t("input.error")}}</a>
      <span class="help" style="width:20px" v-if="daySum > 0 && allreadyRegisteredTime === 0">{{ daySum }}</span>
      <span class="help" style="width:20px" v-else>{{ allreadyRegisteredTime }}</span>
    </div>
    <div class="column" v-if="allreadyRegisteredTime">
      <span style="margin-left:0.5em">
        <a v-on:click="removeRegistrations()" class="delete" style="vertical-align:bottom;"></a>
      </span>
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import {TheMask} from 'vue-the-mask'

export default {
  name: 'TimeMonthInput',
  components: {TheMask},
  props: {
    monthDate: String,
    type: String,
    monthProject: String,
    monthProjectNo: String,
    monthProjectLine: String,
    monthIsApproved: Boolean,
    monthProjectKey: String,
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    const monthDate = this.monthDate || null;
    return {
        allRegistrationsOnSpecificDate: {
          source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + userid).orderByChild('date').equalTo(monthDate),
        },
        orgSettings: {
          source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
          asObject: true,
      },
    }
  },
  data: function() {
    return {
      monthTimeFrom: null,
      monthTimeTo: null,
      dayTimeSum: 0,
      allRegistrationsOnSpecificDate: [],
      showSaveButton: false,
    }
  },
  computed: {
    checkTimeFromError() {
      if(this.monthTimeFrom && this.monthTimeFrom.length > 0 && this.monthTimeFrom.length < 4) {
        return true
      } else {
        return false
      }
    },
    checkTimeToError() {
      if(this.monthTimeTo && this.monthTimeTo.length > 0 && this.monthTimeTo.length < 4) {
        return true
      } else {
        return false
      }
    },
    isApproved() {
      const isApproved = _.find(this.allRegistrationsOnSpecificDate, {'isApproved': true})
      if(isApproved) { return true}
        else {return false}
    },
    allreadyRegisteredTime() {
      const dailySum = _.sumBy(this.allRegistrationsOnSpecificDate, 'time')
      if(this.allRegistrationsOnSpecificDate && this.allRegistrationsOnSpecificDate[0] && this.allRegistrationsOnSpecificDate[0].fromHour) { 
        this.monthTimeFrom = this.allRegistrationsOnSpecificDate[0].fromHour
      }
      if(this.allRegistrationsOnSpecificDate && this.allRegistrationsOnSpecificDate[0] && this.allRegistrationsOnSpecificDate[0].toHour) { 
        this.monthTimeTo = this.allRegistrationsOnSpecificDate[0].toHour 
      }
      return dailySum || 0
    },
    daySum() {
      const from = moment([this.fromHours,this.fromMinutes], "HH:mm")
      const to = moment([this.toHours,this.toMinutes], "HH:mm")
      const total = to.diff(from, 'hours', true)
      if(total > 0 && total !== this.allreadyRegisteredTime) {
        this.$emit('registered-hours', {'from': from , 'to': to, 'total': total});
      }
      return total
    },
    fromHours() {
      const regEx = /^(((([0-1]?[0-9])|(2[0-3]))[:,.][0-5][0-9])|(24:?00))$/
      if(this.monthTimeFrom && this.monthTimeFrom.length > 0) {
        if(this.monthTimeFrom.length === 4 && regEx.test(this.monthTimeFrom)) {
          return Number(this.monthTimeFrom.substring(0, 1))
        } else if(this.monthTimeFrom.length === 5 || (this.monthTimeFrom.length === 4 && !regEx.test(this.monthTimeFrom))) {
          return Number(this.monthTimeFrom.substring(0, 2))
        } else {
            return 0
        }
      } else {
        return 0;
      }
    },
    fromMinutes() {
      const regEx = /^(((([0-1]?[0-9])|(2[0-3]))[:,.][0-5][0-9])|(24:?00))$/
      if(this.monthTimeFrom && this.monthTimeFrom.length >= 0) {
        if((this.monthTimeFrom.length === 4 && regEx.test(this.monthTimeFrom)) || (this.monthTimeFrom.length === 4 && !regEx.test(this.monthTimeFrom))) {
          return Number(this.monthTimeFrom.substring(2, 4))
        } else if(this.monthTimeFrom.length === 5) {
          return Number(this.monthTimeFrom.substring(3, 5))
        } else {
            return 0
        }
      } else {
        return 0;
      }
    },
    toHours() {
      const regEx = /^(((([0-1]?[0-9])|(2[0-3]))[:,.][0-5][0-9])|(24:?00))$/
      if(this.monthTimeTo && this.monthTimeTo.length > 0) {
        if(this.monthTimeTo.length === 4 && regEx.test(this.monthTimeTo)) {
          return Number(this.monthTimeTo.substring(0, 1))
        } else if(this.monthTimeTo.length === 5 || (this.monthTimeTo.length === 4 && !regEx.test(this.monthTimeTo))) {
          return Number(this.monthTimeTo.substring(0, 2))
        } else {
            return 0
        }
      } else {
        return 0;
      }
    },
    toMinutes() {
      const regEx = /^(((([0-1]?[0-9])|(2[0-3]))[:,.][0-5][0-9])|(24:?00))$/
      if(this.monthTimeTo && this.monthTimeTo.length >= 0) {
        if((this.monthTimeTo.length === 4 && regEx.test(this.monthTimeTo)) || (this.monthTimeTo.length === 4 && !regEx.test(this.monthTimeTo))) {
          return Number(this.monthTimeTo.substring(2, 4))
        } else if(this.monthTimeTo.length === 5) {
          return Number(this.monthTimeTo.substring(3, 5))
        } else {
            return 0
        }
      } else {
        return 0;
      }
    },
  },
  methods: {
    checkTimeFormat(time) {
      if(time && time.length === 4) {
        return true
      } else {
        return false
      }
    },
    removeRegistrations() {
      const regsToDelete = _.filter(this.allRegistrationsOnSpecificDate, {'date': this.monthDate})
      this.monthTimeFrom = ''
      this.monthTimeTo = ''
      let deleteCounter = 0
      if(regsToDelete && regsToDelete.length > 0) {
        _.forEach(regsToDelete, (registration) => {
          if(registration.time > 0 && registration.isApproved === false) {
              deleteCounter += 1
              this.$firebaseRefs.allRegistrationsOnSpecificDate.child(registration['.key']).remove()
          }
        })
      } if(deleteCounter === 0) {
          this.$snotify.warning('Registrering kan ikke sletttes', {
              showProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true
              });                    
      }
    },
        checkHourFormatTo(hour) {
      if(Number(hour) > 0 && Number(hour) < 24) {
        setTimeout(() => {
          this.monthTimeTo = hour + ':00'
        }, 1000);
      }
      const regEx = /^(((([0-1]?[0-9])|(2[0-3]))[:,.]?[0-5][0-9])|(24:?00))$/
      return regEx.test(hour)
    },
    checkHourFormatFrom(hour) {
      console.log("hour: " + hour)
      if(Number(hour) > 0 && Number(hour) < 24) {
        setTimeout(() => {
          this.monthTimeFrom = hour + ':00'
        }, 700);
      }
      const regEx = /^(((([0-1]?[0-9])|(2[0-3]))[:,.]?[0-5][0-9])|(24:?00))$/
      return regEx.test(hour)
    },
  }
}
</script>
<style>
  .hour-input {
    width:65px;
    margin-right:2em;
  }
</style>
